<template>
    <div>
<!--&lt;!&ndash;        统计信息&ndash;&gt;-->
<!--&lt;!&ndash;        按钮&ndash;&gt;-->
<!--        <div style="display:flex;margin-left: 20px">-->
<!--     -->

<!--    </div>-->



    </div>
</template>

<script>
    import * as API from "./api"

    import {mapActions} from "vuex";
    export default {
        name: "ImportLeader",
        components:{
            // PunchImport
        },
        data(){
            return{
                // fileList: [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}],

            }
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            //新增
            addPunch(){
                this.addPunchdialog=true
            },
            //关闭弹框
            close(){
                this.addPunchdialog=false
            },
            //批量打卡导入
            batchPunch(){

            },


            // //文件上传
            // handlechange(response,file, fileList) {
            //     this.uploadFile()
            //     console.log(file)
            //    this.fileId=file
            //
            // },


        }
    }
</script>

<style lang="scss" scoped>
.displayflex{
    display: flex;
    justify-content: center
}
/*.upload-input{*/
/*    position: absolute;*/
/*    opacity: 0;*/
/*    width: 70px;*/
/*    height: 80px;*/
/*}*/
</style>